export default function formatPhone(phone) {
    if (!phone || typeof phone !== "string") return "";

    // Normalize input
    const digits = phone.replace(/\D/g, "");

    // Expecting format: +1XXXXXXXXXX or 1XXXXXXXXXX
    if (digits.startsWith("1") && digits.length === 11) {
        const area = digits.slice(1, 4);
        const prefix = digits.slice(4, 7);
        const line = digits.slice(7);
        return `+1 (${area}) ${prefix} ${line}`;
    }

    if (digits.startsWith("+1") && digits.length === 12) {
        const area = digits.slice(2, 5);
        const prefix = digits.slice(5, 8);
        const line = digits.slice(8);
        return `+1 (${area}) ${prefix} ${line}`;
    }

    // Default fallback: return cleaned digits
    return phone;
}